import React from 'react';
import Icon from '../../../components/AppIcon';

const TopPagesTable = ({ pages = [] }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Top Performing Pages</h3>
        <button className="flex items-center gap-2 px-3 py-1.5 text-sm text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors">
          <Icon name="Download" size={16} />
          <span className="hidden sm:inline">Export</span>
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 text-xs md:text-sm font-medium text-muted-foreground">Page</th>
              <th className="text-right py-3 px-2 text-xs md:text-sm font-medium text-muted-foreground">Views</th>
              <th className="text-right py-3 px-2 text-xs md:text-sm font-medium text-muted-foreground">Avg. Time</th>
              <th className="text-right py-3 px-2 text-xs md:text-sm font-medium text-muted-foreground">Bounce Rate</th>
              <th className="text-right py-3 px-2 text-xs md:text-sm font-medium text-muted-foreground">Conversions</th>
            </tr>
          </thead>
          <tbody>
            {pages?.map((page, index) => (
              <tr key={index} className="border-b border-border last:border-0 hover:bg-muted/50 transition-colors">
                <td className="py-3 px-2">
                  <div className="flex items-center gap-2">
                    <Icon name="FileText" size={16} className="text-muted-foreground flex-shrink-0" />
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground truncate">{page?.title}</p>
                      <p className="text-xs text-muted-foreground truncate">{page?.url}</p>
                    </div>
                  </div>
                </td>
                <td className="py-3 px-2 text-right">
                  <span className="text-sm font-medium text-foreground whitespace-nowrap">{page?.views}</span>
                </td>
                <td className="py-3 px-2 text-right">
                  <span className="text-sm text-foreground whitespace-nowrap">{page?.avgTime}</span>
                </td>
                <td className="py-3 px-2 text-right">
                  <div className="flex items-center justify-end gap-2">
                    <span className={`text-sm font-medium whitespace-nowrap ${
                      parseFloat(page?.bounceRate) < 40 ? 'text-success' : 
                      parseFloat(page?.bounceRate) > 60 ? 'text-error': 'text-foreground'
                    }`}>
                      {page?.bounceRate}
                    </span>
                  </div>
                </td>
                <td className="py-3 px-2 text-right">
                  <span className="text-sm font-medium text-foreground whitespace-nowrap">{page?.conversions}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopPagesTable;